import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Grid
} from 'semantic-ui-react';
import update from 'react-addons-update';
import MapSearchBox from '../extras/MapSearchBox';
import BranchOfficeData from "../../data/BranchOfficeData";
import Toast from "../extras/Toast";
import AlertUpgrade from "../extras/AlertUpgrade";

class BranchOfficeDialog extends Component {

    constructor() {
        super();

        this.state = {
            open: false,
            branch: {
                name: '',
                id: null,
                latLng: {lat: 0, lng: 0},
                phone: '',
                address: ''
            },
            name_error: false,
            phone_error: false,
            address_error: false,
            sending: false,
            label_button: " ",
            index: null,
            name: ''
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
    }

    handleNameChange = (event) => {
        let name = update(this.state, {
            branch: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false});
        }
    };

    handlePhoneChange = (event) => {
        let phone = update(this.state, {
            branch: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(phone);
        if (event.target.value.trim() === '') {
            this.setState({phone_error: true})
        } else {
            this.setState({phone_error: false});
        }
    };

    handleAddressChange = (event) => {
        let address = update(this.state, {
            branch: {
                address: {
                    $set: event.target.value
                }
            }
        });
        this.setState(address);
        if (event.target.value.trim() === '') {
            this.setState({address_error: true})
        } else {
            this.setState({address_error: false});
        }
    }

    updateLabels = (branch, index) => {
        if (branch) {
            branch.latLng = {lat:branch.latitude, lng:branch.longitude};
            this.setState({title: "Actualizar Sucursal", label_button: "Actualizar Información", branch, index});
        } else {
            this.setState({
                title: "Nueva sucursal",
                label_button: "Guardar información",
                branch: {
                    name: '',
                    id: null,
                    latitude: 0,
                    longitude: 0,
                    phone: '',
                    address: ''
                },
                name_error: false,
                phone_error: false,
                address_error: false,
                index: null,
            });
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if(this.state.branch.latLng){
            if (this.state.branch.name === '') {
                this.setState({name_error: true});
            } else if (this.state.branch.address === '') {
                this.setState({address_error: true});
            } else if (this.state.branch.phone === '') {
                this.setState({phone_error: true});
            } else if (this.state.branch.latLng.lat === 0) {
                this.refs.toast.show({message: 'Por favor ubica tu restaurante en el mapa!', type: 'error'});
            } else {
                this.setState({sending: true});
                let data = this.state.branch;
                data.latitude = this.state.branch.latLng.lat;
                data.longitude = this.state.branch.latLng.lng;
                if (this.state.branch.id) {
                    BranchOfficeData.update(this.state.branch, (res) => {
                        if (res.hasOwnProperty('id')) {
                            this.props.callbackUpdateData(res, this.state.index);
                            this.refs.toast.show({message: 'Sucursal Actualizada!', type: 'success'});
                        } else {
                            this.refs.toast.show({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                        }
                        this.setState({sending: false, open: false});
                    });
                } else {
                    BranchOfficeData.add(this.state.branch, (res) => {
                        if (res.hasOwnProperty('id')) {
                            this.props.callbackAddData(res);
                            this.refs.toast.show({message: 'Sucursal Agregada!', type: 'success'});
                        }else if(res.hasOwnProperty('detail')){
                            this.refs.alert_upgrade.open();
                        } else {
                            this.refs.toast.show({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                        }
                        this.setState({sending: false, open: false});
                    });
                }
            }
        }
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    getMarkers(markers) {
        let data = update(this.state, {
            branch: {
                latLng: {
                    $set: markers
                }
            }
        });
        this.setState(data);
    }

    render() {
        return (
            <div>
                <Modal size='large' open={this.state.open} dimmer='inverted' onClose={this.handleClose}>
                    <Modal.Header>{this.state.title}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Input label='Nombre' placeholder='Nombre'
                                                        value={this.state.branch.name} onChange={this.handleNameChange}
                                                        error={this.state.name_error}/>
                                            <Form.Input label='Dirección' placeholder='Dirección'
                                                        value={this.state.branch.address}
                                                        onChange={this.handleAddressChange}
                                                        error={this.state.address_error}/>
                                            <Form.Input label='Teléfono' placeholder='Teléfono'
                                                        value={this.state.branch.phone}
                                                        onChange={this.handlePhoneChange}
                                                        error={this.state.phone_error}/>
                                            <br/>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                            <Form.Field>
                                                <label>Ubicación</label>
                                                <MapSearchBox callbackMarkers={this.getMarkers}
                                                              latitude={this.state.branch.latitude}
                                                              longitude={this.state.branch.longitude}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' onClick={this.handleSubmit}
                                content={this.state.label_button} loading={this.state.sending} disabled={this.state.sending}/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
                <AlertUpgrade ref='alert_upgrade'/>
            </div>
        );
    }
}

export default BranchOfficeDialog;



// WEBPACK FOOTER //
// ./src/components/settings/BranchOfficeDialog.js